import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { schema, normalize } from 'normalizr'

const normalizeMyFiles = data => {
  const file = new schema.Entity('files')
  return normalize(data, [file])
}

const MyFilesReducer = combineReducers({
  fetchMyFilesRequest: createRequestReducer('MY_FILES:FETCH'),
  pagination: createReducer(null, {
    'MY_FILES:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      response.data.account.teacher_type &&
      response.data.account.teacher_type.assessment_files_pagination
  }),
  files: createReducer(null, {
    'MY_FILES:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      response.data.account.teacher_type &&
      normalizeMyFiles(response.data.account.teacher_type.assessment_files),
    'MY_FILES:ARCHIVE_REQUEST_SUCCESS': (state, { response, params }) => {
      const files = { ...state.entities.files }
      delete files[params.id]
      return {
        entities: { files },
        result: state.result.filter(id => id !== params.id)
      }
    }
  })
})

export default MyFilesReducer
